export enum TaskUserStatus {
    Assigned = 'Assigned',
    Selected = 'Selected',
    Confirmed = 'Confirmed',
    Rejected = 'Rejected',
    Replaced = 'Replaced',
    Working = 'Working',
    Completed = 'Completed',
}
